export default function Collage3Module(element) {

    let $subelements = element.querySelectorAll('.collage3__item, .collage3__computer');

    function doFloat() {
        $subelements.forEach((elm, index) => {
            let movement = gsap.utils.random(10, 30);
            elm.style.setProperty('--maxtop', movement + 'px');
            elm.classList.add('floating');
        });
    }

    function init() {
        let tl = gsap.timeline({
            defaults: {
                clearProps: true
            },
            onComplete: function() {
                // doFloat();
            }
        });

        $subelements.forEach((elm, index) => {
            tl.from(elm, {rotate: 'random(-5, 5)', y: 200, opacity: 0, duration: 1}, '<0.5')
        });
    }

    init();

    return this;
}
